import { FC } from 'react';

import { Col, Row } from 'antd';

import DataAccordionView from 'components/DataAccordionView/DataAccordionView';
import Education from 'components/Education/Education';
import WorkExperience from 'components/WorkExperience/WorkExperience';

import { useFetchEducationAndExperience } from 'hooks/useFetchEducationAndExperience';

import { useTranslation } from 'react-i18next';
import styles from './EducationWorkExperience.module.scss';

interface EducationWorkExperienceProps {
  jobseekerId?: string | null;
}

const EducationWorkExperience: FC<EducationWorkExperienceProps> = ({
  jobseekerId
}: EducationWorkExperienceProps) => {
  const { t } = useTranslation()
  const {
    education,
    workExperience,
    isLoadingEducation,
    isLoadingWorkExperience
  } = useFetchEducationAndExperience({
    jobseekerId
  });

  return (
    <>
      <Row className={styles.row}>
        <Col span={24}>
          <DataAccordionView
            title={t('common.educationWorkExperience.woTitle')}
            placeholder={
              isLoadingWorkExperience
                ? t('common.educationWorkExperience.woLoading')
                : t('common.educationWorkExperience.woNoAvailable')
            }
          >
            {workExperience ? (
              <WorkExperience workExperience={workExperience} />
            ) : null}
          </DataAccordionView>
        </Col>
      </Row>

      <Row className={styles.row}>
        <Col span={24}>
          <DataAccordionView
            title={t('common.educationWorkExperience.edTitle')}
            placeholder={
              isLoadingEducation
                ? t('common.educationWorkExperience.edLoading')
                : t('common.educationWorkExperience.edNoAvailable')
            }
          >
            {education ? <Education education={education} /> : null}
          </DataAccordionView>
        </Col>
      </Row>
    </>
  );
};

export default EducationWorkExperience;
